import styled from 'styled-components';

import AddressItem from './container';

export default styled(AddressItem)`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 16px 12px;
  gap: 10px;

  width: 100%;
  height: 62px;

  /* grey / 200 */

  border: none;
  border-bottom: 1px solid #e2e8ee;

  background: var(--white);

  &:hover {
    background: #f2f5f8;
  }
`;
